import axios from 'axios';

const BASE_URL = 'https://loyalty.bom.asia';
const API_BASE_URL = `${BASE_URL}/api/miniApp/quiz/loading-screens`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const loadingScreenQuizApi = {
  // Get all loading screens with filters
  getAllLoadingScreens: async (params = {}) => {
    try {
      
      // Build query string
      const queryParams = new URLSearchParams();
      
      // Pagination
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      // Filters
      if (params.search) queryParams.append('search', params.search);
      if (params.isActive !== undefined) queryParams.append('isActive', params.isActive);
      
      const queryString = queryParams.toString();
      const url = queryString ? `/?${queryString}` : '/';
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('❌ Error getting all loading screens:', error);
      throw error;
    }
  },

  // Get loading screen by ID
  getLoadingScreenById: async (id) => {
    try {
      const response = await api.get(`/${id}`);
      return response.data;
    } catch (error) {
      console.error('❌ Error getting loading screen by ID:', error);
      throw error;
    }
  },

  // Upload file and create loading screen
  createLoadingScreen: async (formData) => {
    try {
      
      // Create FormData for file upload
      const uploadFormData = new FormData();
      
      // Add file
      if (formData.file) {
        uploadFormData.append('file', formData.file);
      }
      
      // Add other fields
      if (formData.filename) uploadFormData.append('filename', formData.filename);
      if (formData.mimetype) uploadFormData.append('mimetype', formData.mimetype);
      if (formData.size) uploadFormData.append('size', formData.size);
      if (formData.time) uploadFormData.append('time', formData.time);
      if (formData.isActive !== undefined) uploadFormData.append('isActive', formData.isActive);
      
      const response = await api.post('/', uploadFormData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ Error creating loading screen:', error);
      throw error;
    }
  },

  // Update loading screen
  updateLoadingScreen: async (id, updateData) => {
    try {
      const response = await api.put(`/${id}`, updateData);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating loading screen:', error);
      throw error;
    }
  },

  // Toggle loading screen active status (PATCH endpoint)
  toggleLoadingScreenActive: async (id) => {
    try {
      const response = await api.patch(`/${id}/toggle-active`);
      return response.data;
    } catch (error) {
      console.error('❌ Error toggling loading screen status:', error);
      throw error;
    }
  },

  // Delete loading screen
  deleteLoadingScreen: async (id) => {
    try {
      const response = await api.delete(`/${id}`);
      return response.data;
    } catch (error) {
      console.error('❌ Error deleting loading screen:', error);
      throw error;
    }
  },

  // Helper: Get active loading screens
  getActiveLoadingScreens: async () => {
    try {
      const response = await api.get('/?isActive=true');
      return response.data;
    } catch (error) {
      console.error('❌ Error getting active loading screens:', error);
      throw error;
    }
  },

  // Helper: Search loading screens
  searchLoadingScreens: async (searchTerm) => {
    try {
      const response = await api.get(`/?search=${encodeURIComponent(searchTerm)}`);
      return response.data;
    } catch (error) {
      console.error('❌ Error searching loading screens:', error);
      throw error;
    }
  }
};

export default loadingScreenQuizApi;

